import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UnderConstructionPage from "../UnderConstructionPage/UnderConstructionPage";
/* Working Pages (Hidden while site is under construction)
import HomePage6 from "../HomePage6/HomePage6";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import ContactPage from "../ContactPage/ContactPage";
import HelpUs from "../HelpUsPage/HelpUs";
import KycUploadPage from "../HelpUsPages/KycUploadPage";
import FinishCheck from "../HelpUsPages/FinishCheck";
import LivenessCheck from "../HelpUsPages/LivenessCheck";
import OnboardingFAQ from "../HelpUsPages/OnboardingFAQ";
import DataSafty from "../HelpUsPages/DataSafty";
import GeneralFaq from "../HelpUsPages/GeneralFaq";
import MoneyTransfer from "../MoneyTransferPage/MoneyTransfer";
import Terms from "../FooterPages/TermsConditionPage";
import PrivacyPagee from "../FooterPages/PrivacyPage";
import ComplaintPolicy from "../FooterPages/ComplaintPolicy";
import DownloadApp from "../DownloadPage/DownloadApp";
*/

const AllRoute = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Under Construction mode enabled for all routes */}
          <Route path="*" element={<UnderConstructionPage />} />

          {/* 
          Standard Routes (To reactivate, uncomment below and disable wildcard above):
          <Route path="/" element={<HomePage6 />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="help" element={<HelpUs />} />
          <Route path="kycupload" element={<KycUploadPage />} />
          <Route path="finishcheck" element={<FinishCheck />} />
          <Route path="livenesscheck" element={<LivenessCheck />} />
          <Route path="onboardingFAQ" element={<OnboardingFAQ />} />
          <Route path="datasafty" element={<DataSafty />} />
          <Route path="generalFaq" element={<GeneralFaq />} />
          <Route path="moneytransfer" element={<MoneyTransfer />} />
          <Route path="terms-condition" element={<Terms />} />
          <Route path="privacy-policy" element={<PrivacyPagee />} />
          <Route path="complaint-policy" element={<ComplaintPolicy />} />
          <Route path="download-buga-app" element={<DownloadApp />} />
          */}
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;

